module.exports = __webpack_public_path__ + "static/media/PokoroPen.663583b1.png";